﻿import { forwardRef, useContext, useEffect, useImperativeHandle, useRef } from 'react';
import * as React from 'react';

import { ReportsDefaultContext } from 'pages/reports/context/ReportsDefaultContext';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useSuperState } from 'hooks';
import { useApp } from 'app';

export const QuestionViewer = forwardRef((props, forwardRef) => {

    const { currentUserId } = useContext(ReportsDefaultContext);
    const { cultureId } = useApp();
    const loadTimeout = useRef<number | null>(null);
    const [state, setState, resetState] = useSuperState({
        allQuestions: [] as any,
        iframeLoading: true,
        isInAppTest: false,
        modalTitle: '',
        objectivePassPercentage: 0,
        questionId: '',
        questionIndex: -1,
        resultId: null,
        showModal: false,
        studentProfileId: ''
    });

    const { allQuestions, iframeLoading, isInAppTest, modalTitle, objectivePassPercentage, questionId, questionIndex, resultId, showModal, studentProfileId } = state;

    useEffect(() => {

        if (loadTimeout.current) {

            clearTimeout(loadTimeout.current);

        }

    }, []);

    const createModal = (props: any) => {

        setState({
            allQuestions: props.allQuestions,
            isInAppTest: props.isInAppTest,
            modalTitle: props.modalTitle,
            objectivePassPercentage: getPercentage(props.objectivePassPercentage),
            questionId: props.questionId,
            questionIndex: props.questionIndex,
            resultId: props.resultId,
            showModal: true,
            studentProfileId: props.studentProfileId
        });

    };

    const getPercentage = score => {

        const obtained = Number(score.split('/')[0]);
        const possible = Number(score.split('/')[1]);
        let percentage = ((obtained * 1) / (possible * 1)) * 100;
        if (Number.isNaN(obtained) && Number.isNaN(possible)) {

            percentage = Number(score.split('%')[0]);

        }

        return percentage;

    };

    const goToPreviousQuestion = () => {

        if (questionIndex > 0) {

            const previousQuestion = allQuestions[questionIndex - 1];

            setState({
                iframeLoading: true,
                modalTitle: previousQuestion.Title,
                objectivePassPercentage: getPercentage(previousQuestion.Share),
                questionId: previousQuestion.QuestionId,
                questionIndex: questionIndex - 1
            });

        }

    };

    const goToNextQuestion = () => {

        if (questionIndex < allQuestions.length - 1) {

            const nextQuestion = allQuestions[questionIndex + 1];

            setState({
                iframeLoading: true,
                modalTitle: nextQuestion.Title,
                objectivePassPercentage: getPercentage(nextQuestion.Share),
                questionId: nextQuestion.QuestionId,
                questionIndex: questionIndex + 1
            });

        }

    };

    useImperativeHandle(forwardRef, () => ({
        create: createModal
    }), []);

    const handleHide = () => {

        resetState();

    };

    const host = window.location.host.toLowerCase();

    let baseUrl = 'gmetrix.net';

    if (host.includes('devmanage')) {

        baseUrl = 'dev.gmetrix.net';

    } else if (host.includes('stagemanage')) {

        baseUrl = 'stage.gmetrix.net';

    } else if (host.includes('localhost')) {

        // baseUrl = 'localhost:44325';

        baseUrl = 'dev.gmetrix.net';

        // baseUrl = 'gmetrix.net';

    }

    return (
        <Modal centered onHide={handleHide} show={showModal} size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>
                    {modalTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-medium'>
                <div className='ratio ratio-4x3'>
                    {iframeLoading && (
                        <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
                            <GMetrixLoader size='large' />
                        </div>
                    )}
                    <iframe

                        onLoad={() => {

                            if (loadTimeout.current) {

                                clearTimeout(loadTimeout.current);

                            }
                            loadTimeout.current = window.setTimeout(() => {

                                setState({ iframeLoading: false });

                            }, 300);

                        }}
                        src={questionId ? (
                            isInAppTest ? (
                                `https://${baseUrl}/open-question-viewer?QuestionId=${questionId}&langId=${cultureId}&teacherId=${currentUserId}&studentId=${studentProfileId}`
                            ) : (
                                `https://${baseUrl}/open-question-viewer?resultId=${resultId}&questionId=${questionId}&objectivepasspercentage=${objectivePassPercentage}&studentId=${studentProfileId}&review=true`
                            )
                        ) : 'about:blank'}
                        style={{
                            opacity: iframeLoading ? 0 : 1,
                            transition: 'opacity 0.2s ease-in-out',
                            visibility: iframeLoading ? 'hidden' : 'visible'
                        }}
                    />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    className='me-auto'
                    onClick={handleHide}
                    variant='secondary'
                >
                    <FormattedMessage defaultMessage="Close" id="close.99e01fb5" />
                </Button>
                <Button
                    disabled={questionIndex <= 0}
                    onClick={goToPreviousQuestion}
                    variant="primary"
                >
                    <FormattedMessage defaultMessage="Previous" id="previous.f825144b" />
                </Button>
                <Button
                    disabled={questionIndex >= allQuestions.length - 1}
                    onClick={goToNextQuestion}
                    variant="primary"
                >
                    <FormattedMessage defaultMessage="Next" id="next.50b7834e" />
                </Button>
            </Modal.Footer>
        </Modal>
    );

});

QuestionViewer.displayName = 'QuestionViewer';